const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client-health/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { RANGES } from "@/components/client-health/health-bits";
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { ClientHealthRow, ClientHealthStatus } from "@/types/api/client-health";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client-health/")({
  beforeLoad: args => requirePermission(Permissions.Dashboard.ViewClientHealth, args),
  validateSearch: (search: Record<string, unknown>): {
    days?: number;
  } => {
    const days = Number(search.days);
    return RANGES.some(r => r.days === days) ? {
      days
    } : {};
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Filter = "All" | ClientHealthStatus;

/**
 * Client health: one row per company with its errors, failed calls and activity, companies
 * with problems first. Click a row for that company's problems. Figures come from Application
 * Insights (calls, errors, users) and the database (inspections).
 */